import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendar2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCalendar2"><Path fillRule="evenodd" clipRule="evenodd" d="M9 2V4H15V2H17V4H21V21H3V4H7V2H9ZM19 11H5V19H19V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalendar2;
